<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container">
          <div v-html="$t('Footer.legalrules')" class="small"></div>
        </div>
  </div>
  <footer class="py-4">

      <div class="navbar px-4 py-0">
        <div class="col">
      <ul class="list-inline mb-0" id="footer-nav">      
        <li class="list-inline-item ps-0" v-html="$t('Footer.T&CLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
        </li>
      </ul>
      <p class="mt-4 mt-sm-1 mb-0 pe-md-5 small">
      {{ $t('Footer.copyrighttext') }} {{ new Date().getFullYear() }}. {{ $t('Footer.AllrightReserved') }}
      </p>

    </div> 
    <div class="footer-right me-0 me-sm-5">
      <div class="footer-social-nav">
        <ul class="list-inline m-0">
          <li class="text-uppercase fw-bold">{{ $t('Footer.FollowUs') }}</li>
          <li>
            <a
              href="https://www.facebook.com/ahcatlitter/"
              class="fb-link social-icon"
              title="facebook"
              target="_blank"
            >
              <i class="fab fa-facebook"></i>
            </a>
          </li>
          <li>
            <a
              href="https://x.com/armandhammercat"
              class="x-link social-icon"
              title="X"
              target="_blank"
            >
              <i class="fab fa-x-twitter"></i>
            </a>
          </li>
         <li>
            <a
              href="https://www.instagram.com/armandhammer"
              class="ig-link social-icon"
              title="instagram"
              target="_blank"
            >
              <i class="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/user/AHBakingSoda"
              class="yt-link social-icon"
              title="youtube"
              target="_blank"
            >
              <i class="fab fa-youtube"></i>
            </a>
          </li>
        </ul>
      </div>
     
    </div>
 </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
     const modelHash = this.$t('YounetmodelHash');
     const modelImgurl = this.$t('YounetmodelIMg');
     const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=85`;

    // // Dynamically create the script element
     const script = document.createElement('script');
     script.type = 'module';
     script.src = scriptUrl;

    // // Append the script to the body
     document.body.appendChild(script);
  },
};
</script>


